import { FunctionComponent, PropsWithChildren } from 'react';

interface SettingsGroupListProps extends PropsWithChildren {}

const SettingsGroupList: FunctionComponent<SettingsGroupListProps> = ({ children }) => {
  return <div className="max-w-(--breakpoint-lg) flex flex-col gap-y-6">{children}</div>;
};

export default SettingsGroupList;
